import { TemplatePage } from './types';

const valentinesDayPage: TemplatePage = {
  header: {
    color: '#FDC7C5',
    icon: 'images/video-templates/valentine.jpg',
    title: 'Valentine’s Day Video Templates',
    title_meta: '500+ Customizable Vantine’s Day Video Templates',
    description_meta:
      'Make it special with easily personalizable Valentine’s Day free video templates that will bring you closer ' +
      'to your audience and friends and help you with sales, ads, engagement, and conversions while leaving your ' +
      'audience to crave for more.',
    description:
      'Make it special with easily personalizable Valentine’s Day free video templates. Bring your valentines to ' +
      'a whole new level by sending your audience a video on social media or in email.'
  },
  footer: {
    category: 'Valentine’s Day',
    description:
      'Wave.video’s collection of Valentine’s Day video templates, offers you plenty of beautiful choices. ' +
      'Customizing them is as easy as one-two-three! It’s a great opportunity to remind your audience about ' +
      'you and your products and services, to run a sale, discount, ad or promotion, or just wish them all ' +
      'the best. Select from a vast variety of beautiful videos in all popular formats. Video ads will bring ' +
      'your sales up while entertaining your audience and increasing engagement. '
  },
  content: [
    {
      type: 'templates',
      title: 'Valentine’s Day Video Templates',
      search: {
        category: "/Holidays & Occasions/Valentine's Day"
      }
    },
    {
      type: 'stocks',
      title: 'Valentine’s Day',
      search: { name: 'valentine day' }
    },
    { type: 'calendar' }
  ]
};

export default valentinesDayPage;
